import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Customer from '../../pages/MasterFiles/Customer/Customer'
import Vehicle from "./VehicleMaster/VehicleHome";
import SpareParts from "./SpareParts/SpareParts";
import Labour from "./Labour/Labour";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {/* {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )} */}
      {value === index && children}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Master() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Customer" {...a11yProps(0)} />
            <Tab label="Vehicle" {...a11yProps(1)} />
            <Tab label="Spare parts" {...a11yProps(2)} />
            <Tab label="Labour" {...a11yProps(3)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <Customer />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <Vehicle />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
         <SpareParts/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
         <Labour/>
        </CustomTabPanel>
      </Box>
  );
}
export default Master;
